import { useEffect, useRef, useState } from "react";
import Image from "next/image";
import style from "./ExampleScroll.module.scss";
import { useScroll } from "framer-motion";
import useLazyVideo from "../../../utils/hooks/useLazyVideo";

function ExamplesScroll({ dictionary, scrollData }) {
	const [progress, setProgress] = useState(0);
	const [isAdaptive, setIsAdaptive] = useState(false);

	const [containerRef, videoRef, isInView] = useLazyVideo();
	const scrollContainer = useRef(null);
	const { scrollYProgress } = useScroll({ container: scrollContainer });

	scrollYProgress.onChange((item) => {
		setProgress(item);
	});

	useEffect(() => {
		const getWindowWidth = () => {
			window.innerWidth <= 768 ? setIsAdaptive(true) : setIsAdaptive(false);
		};

		getWindowWidth();

		window.addEventListener("resize", getWindowWidth);

		return () => window.removeEventListener("resize", getWindowWidth);
	}, []);

	return (
		<section className={style.container} ref={containerRef}>
			<div className={style.text}>
				<h2 className={style.title}>{dictionary["page_interior_h3"]}</h2>
				<p className={style.description}>{dictionary["page_interior_desc_3"]}</p>
			</div>
			<div className={style.progressContainer}>
				<div className={style.progressBar} style={{ left: `${progress * 100 > 10 ? progress * 100 - 15 : -10}%` }}></div>
			</div>
			<div className={style.content} ref={scrollContainer}>
				<div className={style.scroll}>
					{scrollData.map((item) => (
						<div key={item.id} className={style.item}>
							<span className={style.label}>{dictionary[item.label]}</span>
							<Image src={item.url} alt={`${item.label} image`} width={750} height={440} loading="lazy" className={style.image} />
						</div>
					))}
				</div>
			</div>
			<video ref={videoRef} className={style.video} autoPlay={isInView && isAdaptive} loop muted playsInline preload="none" poster={"/interior_design/examples_scroll/before_4.jpg"}>
				<source src={isAdaptive && isInView ? "/interior_design/examples_scroll/adaptive_scroll.mp4" : ""} type="video/mp4" />
			</video>
		</section>
	);
}

export default ExamplesScroll;
